module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "sidebar-menu",
    on: {
      "mouseenter": _vm.checkShowViewFont
    }
  }, [_c('li', {
    staticClass: "header"
  }, [_vm._v("MAIN NAVIGATION")]), _vm._v(" "), _c('router-link', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$route.path == '/'),
      expression: "$route.path == '/'"
    }],
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-th"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Project")])])]), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowInformation),
      expression: "isShowInformation"
    }],
    class: _vm.$route.path === '/information' ? 'treeview active' : 'treeview'
  }, [_c('a', {
    staticClass: "version-manage"
  }, [_c('i', {
    staticClass: "fa fa-file-text"
  }), _vm._v(" "), _c('span', {
    class: _vm.isShowTreeViewFont ? 'pull-right-container' : 'pull-right-container hidden'
  }, [_vm._v("Information")]), _vm._v(" "), _c('span', {
    class: _vm.isShowTreeViewFont ? 'pull-right-container' : 'pull-right-container hidden'
  }, [_c('i', {
    staticClass: "fa fa-angle-left fa-fw pull-right"
  })])]), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [_c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowInformation),
      expression: "isShowInformation"
    }],
    class: _vm.$route.path === '/information' ? 'active' : ''
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/information/app?appid=' + _vm.$route.query.appid + '&appname=' + _vm.$route.query.appname
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-adn"
  }), _vm._v(" App\n        ")])], 1), _vm._v(" "), (_vm.isAdminAndHasAppid) ? _c('li', {
    class: _vm.$route.path === '/information/devicetypes' ? 'active' : ''
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/information/devicetypes',
        query: {
          appid: _vm.$route.query.appid,
          appname: _vm.$route.query.appname,
        }
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-tumblr"
  }), _vm._v(" DeviceTypes\n        ")])], 1) : _vm._e(), _vm._v(" "), (_vm.isAdminAndHasAppid) ? _c('li', {
    class: _vm.$route.path === '/information/deviceaddon' ? 'active' : ''
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/information/deviceaddon',
        query: {
          appid: _vm.$route.query.appid,
          appname: _vm.$route.query.appname,
        }
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-puzzle-piece"
  }), _vm._v(" DeviceAddon\n        ")])], 1) : _vm._e(), _vm._v(" "), (_vm.isAdminAndHasAppid) ? _c('li', {
    class: _vm.$route.path === '/information/deviceaddonclient' ? 'active' : ''
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/information/deviceaddonclient',
        query: {
          appid: _vm.$route.query.appid,
          appname: _vm.$route.query.appname,
        }
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plug"
  }), _vm._v(" DeviceAddonClient\n        ")])], 1) : _vm._e(), _vm._v(" "), (_vm.isAdminAndHasAppid) ? _c('li', {
    class: _vm.$route.path === '/information/apnsrelation' ? 'active' : ''
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/information/apnsrelation',
        query: {
          appid: _vm.$route.query.appid,
          appname: _vm.$route.query.appname,
        }
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-comment"
  }), _vm._v(" Apns Relation\n        ")])], 1) : _vm._e()])]), _vm._v(" "), _c('router-link', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowAddApp),
      expression: "isShowAddApp"
    }],
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/addapp"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-file-text"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Add App")])])]), _vm._v(" "), _c('router-link', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowAdmin),
      expression: "isShowAdmin"
    }],
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": {
        path: '/agent?appid=' + _vm.$route.query.appid + '&appname=' + _vm.$route.query.appname
      }
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-user"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Administrator")])])]), _vm._v(" "), _c('router-link', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isShowAboutDevice && _vm.$route.path != '/' && !_vm.isShowAddApp),
      expression: "!isShowAboutDevice&&$route.path!='/'&&!isShowAddApp"
    }],
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": {
        path: '/device?appid=' + _vm.$route.query.appid + '&appname=' + _vm.$route.query.appname
      }
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-desktop"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Device")])])]), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowAboutDevice),
      expression: "isShowAboutDevice"
    }],
    staticClass: "treeview active",
    attrs: {
      "id": "devicetreeview"
    }
  }, [_c('a', {
    on: {
      "click": _vm.toDevice
    }
  }, [_c('i', {
    staticClass: "fa fa-desktop"
  }), _vm._v(" "), _c('span', {
    class: _vm.isShowTreeViewFont ? 'pull-right-container' : 'pull-right-container hidden'
  }, [_vm._v("Device")]), _vm._v(" "), _c('span', {
    class: _vm.isShowTreeViewFont ? 'pull-right-container' : 'pull-right-container hidden'
  }, [_c('i', {
    staticClass: "fa fa-angle-left fa-fw pull-right"
  })])]), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu active",
    attrs: {
      "id": "devicetreemenu"
    }
  }, [_c('li', {
    class: _vm.$route.path === '/aboutdevice' ? 'active' : ''
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/aboutdevice?appid=' + _vm.$route.query.appid + '&appname=' + _vm.$route.query.appname + '&devicename=' + encodeURIComponent(_vm.$route.query.devicename) + '&deviceid=' + _vm.$route.query.deviceid + '&online=' + _vm.$route.query.online + '&t=' + _vm.$router.app.$store.state.devicetoken
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-database active"
  }), _vm._v(" About Device\n        ")])], 1), _vm._v(" "), _c('li', {
    class: _vm.$route.path === '/parametersetting' ? 'active' : ''
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/parametersetting?appid=' + _vm.$route.query.appid + '&appname=' + _vm.$route.query.appname + '&devicename=' + encodeURIComponent(_vm.$route.query.devicename) + '&deviceid=' + _vm.$route.query.deviceid + '&online=' + _vm.$route.query.online + '&t=' + _vm.$router.app.$store.state.devicetoken
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-cog"
  }), _vm._v(" Parameter Setting\n        ")])], 1), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isAgentAdmin),
      expression: "isAgentAdmin"
    }],
    class: _vm.$route.path === '/eventlist' ? 'active' : ''
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/eventlist?appid=' + _vm.$route.query.appid + '&appname=' + _vm.$route.query.appname + '&devicename=' + encodeURIComponent(_vm.$route.query.devicename) + '&deviceid=' + _vm.$route.query.deviceid + '&online=' + _vm.$route.query.online + '&t=' + _vm.$router.app.$store.state.devicetoken
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-list-ul"
  }), _vm._v(" Event List\n        ")])], 1), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isAdminAndHasAppid),
      expression: "isAdminAndHasAppid"
    }],
    class: _vm.$route.path === '/deviceupgrade' ? 'active' : ''
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/deviceupgrade?appid=' + _vm.$route.query.appid + '&appname=' + _vm.$route.query.appname + '&devicename=' + encodeURIComponent(_vm.$route.query.devicename) + '&deviceid=' + _vm.$route.query.deviceid + '&online=' + _vm.$route.query.online + '&t=' + _vm.$router.app.$store.state.devicetoken
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-upload"
  }), _vm._v(" Upgrade\n        ")])], 1), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isAdminAndHasAppid),
      expression: "isAdminAndHasAppid"
    }],
    class: _vm.$route.path === '/devicelog' ? 'active' : ''
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/devicelog?appid=' + _vm.$route.query.appid + '&appname=' + _vm.$route.query.appname + '&devicename=' + encodeURIComponent(_vm.$route.query.devicename) + '&deviceid=' + _vm.$route.query.deviceid + '&online=' + _vm.$route.query.online + '&t=' + _vm.$router.app.$store.state.devicetoken
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-file-code-o"
  }), _vm._v(" Log\n        ")])], 1), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }]
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/device?appid=' + _vm.$route.query.appid + '&appname=' + _vm.$route.query.appname + '&devicename=' + encodeURIComponent(_vm.$route.query.devicename) + '&deviceid=' + _vm.$route.query.deviceid
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-file-code-o"
  }), _vm._v(" Log\n        ")])], 1)])]), _vm._v(" "), _c('router-link', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowProblemDevices),
      expression: "isShowProblemDevices"
    }],
    class: _vm.$route.path === '/problemdevicelist' ? 'active' : '',
    attrs: {
      "to": {
        path: '/problemdevicelist?appid=' + _vm.$route.query.appid + '&appname=' + _vm.$route.query.appname + '&online=' + _vm.$route.query.online + '&t=' + _vm.$router.app.$store.state.devicetoken
      },
      "tag": "li"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-exclamation-triangle"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Problem Devices")])])]), _vm._v(" "), _c('router-link', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowUser),
      expression: "isShowUser"
    }],
    class: _vm.$route.path === '/deviceuser' ? 'active pageLink' : 'pageLink',
    attrs: {
      "tag": "li",
      "to": {
        path: '/deviceuser?appid=' + _vm.$route.query.appid + '&appname=' + _vm.$route.query.appname
      }
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-users"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Device's Member")])])]), _vm._v(" "), _c('router-link', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowAccessory),
      expression: "isShowAccessory"
    }],
    class: _vm.$route.path === '/accessory' ? 'active pageLink' : 'pageLink',
    attrs: {
      "tag": "li",
      "to": {
        path: '/accessory?appid=' + _vm.$route.query.appid + '&appname=' + _vm.$route.query.appname
      }
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-cubes"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Accessory")])])]), _vm._v(" "), _c('router-link', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowFeedback),
      expression: "isShowFeedback"
    }],
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": {
        path: '/feedback?appid=' + _vm.$route.query.appid + '&appname=' + _vm.$route.query.appname
      }
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-commenting"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Feedback")])])]), _vm._v(" "), (_vm.isAdminAndHasAppid) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": {
        path: '/oauth2',
        query: {
          appid: _vm.$route.query.appid,
          appname: _vm.$route.query.appname,
        }
      }
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-shield"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("OAuth2")])])]) : _vm._e(), _vm._v(" "), (_vm.isAdminAndHasAppid) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": {
        path: '/domain',
        query: {
          appid: _vm.$route.query.appid,
          appname: _vm.$route.query.appname,
        }
      }
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-globe"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Domain")])])]) : _vm._e(), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowAnalysis),
      expression: "isShowAnalysis"
    }],
    class: _vm.$route.path === '/analysis' ? 'treeview active' : 'treeview'
  }, [_c('a', {
    staticClass: "version-manage"
  }, [_c('i', {
    staticClass: "fa fa-bar-chart"
  }), _vm._v(" "), _c('span', {
    class: _vm.isShowTreeViewFont ? 'pull-right-container' : 'pull-right-container hidden'
  }, [_vm._v("Data Analysis")]), _vm._v(" "), _c('span', {
    class: _vm.isShowTreeViewFont ? 'pull-right-container' : 'pull-right-container hidden'
  }, [_c('i', {
    staticClass: "fa fa-angle-left fa-fw pull-right"
  })])]), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [_c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowTestDeviceAnalysis),
      expression: "isShowTestDeviceAnalysis"
    }],
    class: _vm.$route.path === '/analysis/testdeviceanalysis' ? 'active' : ''
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/analysis/testdeviceanalysis?appid=' + _vm.$route.query.appid + '&appname=' + _vm.$route.query.appname
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-flask"
  }), _vm._v(" Test Device Analysis\n        ")])], 1), _vm._v(" "), _c('li', {
    class: _vm.$route.path === '/analysis/connection' ? 'active' : ''
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/analysis/connection',
        query: {
          appid: _vm.$route.query.appid,
          appname: _vm.$route.query.appname,
        }
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-flask"
  }), _vm._v(" Connection Analysis\n        ")])], 1)])]), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasAppId),
      expression: "hasAppId"
    }],
    class: _vm.$route.path === '/compilation' ? 'treeview active' : 'treeview',
    attrs: {
      "id": "roboottreeview"
    }
  }, [_c('a', {
    staticClass: "version-manage"
  }, [_c('i', {
    staticClass: "fa fa-vimeo"
  }), _vm._v(" "), _c('span', {
    class: _vm.isShowTreeViewFont ? 'pull-right-container' : 'pull-right-container hidden'
  }, [_vm._v("Version Management")]), _vm._v(" "), _c('span', {
    class: _vm.isShowTreeViewFont ? 'pull-right-container' : 'pull-right-container hidden'
  }, [_c('i', {
    staticClass: "fa fa-angle-left fa-fw pull-right"
  })])]), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu",
    attrs: {
      "id": "robottreemenu"
    }
  }, [_c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowCompilation),
      expression: "isShowCompilation"
    }],
    class: _vm.$route.path === '/compilation/master' ? 'active' : ''
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/compilation/master?appid=' + _vm.$route.query.appid + '&appname=' + _vm.$route.query.appname + '&typeid=M0'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-circle-up"
  }), _vm._v(" Master\n        ")])], 1), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowCompilation),
      expression: "isShowCompilation"
    }],
    class: _vm.$route.path === '/compilation/android' ? 'active' : ''
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/compilation/android?appid=' + _vm.$route.query.appid + '&appname=' + _vm.$route.query.appname + '&typeid=M3'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-android"
  }), _vm._v(" Android\n        ")])], 1), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowCompilation),
      expression: "isShowCompilation"
    }],
    class: _vm.$route.path === '/compilation/ios' ? 'active' : ''
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/compilation/ios?appid=' + _vm.$route.query.appid + '&appname=' + _vm.$route.query.appname + '&typeid=M2'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-apple"
  }), _vm._v(" IOS\n        ")])], 1), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowCompilation),
      expression: "isShowCompilation"
    }],
    class: _vm.$route.path === '/compilation/robotlist' ? 'active' : ''
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/compilation/robotlist?appid=' + _vm.$route.query.appid + '&appname=' + _vm.$route.query.appname
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-simplybuilt"
  }), _vm._v(" Robot List\n        ")])], 1), _vm._v(" "), _c('li', {
    class: _vm.$route.path === '/compilation/mobileclientsupdatelogs' ? 'active' : ''
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/compilation/mobileclientsupdatelogs?appid=' + _vm.$route.query.appid + '&appname=' + _vm.$route.query.appname
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-envelope"
  }), _vm._v(" Mobile Clients Update Logs\n        ")])], 1), _vm._v(" "), _c('li', {
    class: _vm.$route.path === '/compilation/masterslavesupdatelogs' ? 'active' : ''
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/compilation/masterslavesupdatelogs?appid=' + _vm.$route.query.appid + '&appname=' + _vm.$route.query.appname
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-envelope"
  }), _vm._v(" Master / Slave Update Logs\n        ")])], 1), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowCompilation),
      expression: "isShowCompilation"
    }],
    class: _vm.$route.path === '/compilation/generalsetting' ? 'active' : ''
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/compilation/generalsetting?appid=' + _vm.$route.query.appid + '&appname=' + _vm.$route.query.appname
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-envelope"
  }), _vm._v(" Notification Settings\n        ")])], 1)])]), _vm._v(" "), (_vm.isAdminAndHasAppid) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": {
        path: '/dinnewsweekly',
        query: {
          appid: _vm.$route.query.appid,
          appname: _vm.$route.query.appname,
        }
      }
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-book"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("News Weekly")])])]) : _vm._e()], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-b31df5a0", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b31df5a0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SidebarMenu.vue
// module id = 493
// module chunks = 1